import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Spinner } from '@datacamp/campus-integration';
import * as React from 'react';
import { withTranslation } from 'react-i18next';
import { jsx as ___EmotionJSX } from "@emotion/react";
const defaultProps = {
  initialized: true,
  isRequesting: false,
  resetting: false
};
export class WorkbookFrame extends React.Component {
  createIframeLink() {
    const {
      workbook
    } = this.props;
    return "".concat(workbook.url, "&rm=embedded&hl=en");
  }
  render() {
    const {
      initialized,
      isRequesting,
      resetting,
      t,
      workbook
    } = this.props;
    let text;
    if (workbook === null || isRequesting) {
      text = t('WorkbookFrame.creatingWorkbook');
    } else if (!initialized) {
      text = t('WorkbookFrame.initializingWorkbook');
    } else if (resetting) {
      text = t('WorkbookFrame.resettingWorkbook');
    }
    return [(workbook === null || isRequesting || !initialized || resetting) && ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Spinner, null), text), workbook !== null && !resetting && !isRequesting && ___EmotionJSX("iframe", {
      className: "workbook__frame dc-u-fxi-f-1 dc-u-b-none",
      key: "workbook",
      src: this.createIframeLink(),
      style: {
        display: "".concat(initialized ? '' : 'none')
      },
      title: "Workbook"
    })];
  }
}
_defineProperty(WorkbookFrame, "defaultProps", defaultProps);
export default withTranslation()(WorkbookFrame);